import styled, { css } from 'styled-components';
import { color, flexbox, layout, space, typography, variant, border, shadow, position } from 'styled-system';
import { theme } from '@styles';

export const Typography = styled.p`
  ${({
    pointer,
    textTransform = 'none',
    textDecoration = 'none',
    textOverflow = 'inherit',
    whiteSpace = 'normal',
    wordBreak = 'normal',
  }) => css`
    text-transform: ${textTransform};
    text-decoration: ${textDecoration};
    white-space: ${whiteSpace};
    color: ${theme.color.gray[500]};
    word-break: ${wordBreak};
    ${pointer && 'cursor: pointer;'}

    ${variant({
      variants: {
        'proximaNova-400': {
          fontFamily: 'Proxima Nova',
          fontWeight: 400,
        },
        'proximaNova-600': {
          fontFamily: 'Proxima Nova',
          fontWeight: 600,
        },
        'garamond-500': {
          fontFamily: 'EB Garamond',
          fontWeight: 500,
        },
        'diatype-300': {
          fontFamily: 'Diatype',
          fontWeight: 300,
        },
        'diatype-400': {
          fontFamily: 'Diatype',
          fontWeight: 400,
        },
        'diatype-500': {
          fontFamily: 'Diatype',
          fontWeight: 500,
        },
        'rightserif-400': {
          fontFamily: 'Right Serif',
          fontWeight: 400,
        },
      },
    })}
    ${border};
    ${color};
    ${flexbox};
    ${layout};
    ${space};
    ${typography};
    ${shadow};
    ${position}

    text-overflow: ${textOverflow};
  `}
`;
